import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';

// Services
import { RevenueTypeEditService } from '../../service/revenue-type-edit/revenue-type-edit.service';

@Component({
	selector: 'app-revenue-type-edit',
	templateUrl: './revenue-type-edit.component.html',
	providers: [
	RevenueTypeEditService,
	HttpModule
	]
})
export class RevenueTypeEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	revenuType: FormGroup;
	ID: string;
	Nome: string;
	Descricao: string;
	Ativo: boolean;
	UsuarioIDCriacao: string;
	DataCriacao: any;

	constructor(fb: FormBuilder, private revenueTypeEditService: RevenueTypeEditService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.revenuType = fb.group({
			'ID': '',
			'Descricao': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.revenueTypeEditService.loadRevenueType(this.token, this.ID).subscribe(result => {
				console.log(result.Result);
				var updateRevenueType = result.Result;
				this.revenuType.setValue({
					ID: updateRevenueType.ID,
					Descricao: updateRevenueType.Descricao,
					Ativo: updateRevenueType.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editRevenueType(value: any) {
		console.log(value);
		this.revenueTypeEditService.editRevenueType(this.token, value).subscribe(result => {
			if (result.Success)
				this.router.navigateByUrl('/tipo-receita');

		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/tipo-receita');
	}

}



// WEBPACK FOOTER //
// ./src/app/revenue-type/component/revenue-type-edit/revenue-type-edit.component.ts